import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './PlanInfo.css';
import PlanInfoFeaturesList from './PlanInfoFeaturesList';

interface EssentialsInfoProps {
    includeHeader?: boolean;
}

const EssentialsInfo = ({ includeHeader = false }: EssentialsInfoProps) => {
    const { t } = useTranslation();
    return (
        <>
            {includeHeader && (
                <h1>
                    {t('plan_info_you_are_on', { sprintf: [t('plan_info_type_essentials')] })}.{' '}
                    {t('plan_info_whats_included')}:
                </h1>
            )}
            <div className="InfoPage-features">
                <a
                    href="https://support.fieldmargin.com/en/articles/6478752-what-is-the-30-day-history-limit"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/history.png"
                        alt="Screenshot of activity list in the fieldmargin web app"
                    />
                    <h2>{t('unlimited_history')}</h2>
                    <p>{t('free_history_desc')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/3455788-viewing-your-field-history-and-inputs"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/reporting.png"
                        alt="Screenshot of field history reporting in the fieldmargin mobile app"
                    />
                    <h2>{t('plan_info_title_basic_reporting')}</h2>
                    <p>{t('plan_info_body_basic_reporting')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/4480123-how-to-manage-livestock-and-grazing"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/livestock.png"
                        alt="Photo of cows in a shed"
                    />
                    <h2>{t('plan_info_title_two_livestock_herds')}</h2>
                    <p>{t('plan_info_body_two_livestock_herds')}</p>
                </a>
                <a
                    href="http://support.fieldmargin.com/en/articles/3448658-input-limits"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/inputs.png"
                        alt="Screenshot of field input reporting on the fieldmargin mobile app"
                    />
                    <h2>{t('plan_info_title_five_inputs')}</h2>
                    <p>{t('plan_info_body_five_inputs')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/2380970-printing-your-farm-map"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/map-printing.png"
                        alt="Screenshot of fields shown on a satellite map"
                    />
                    <h2>{t('map_printing')}</h2>
                    <p>{t('plan_info_body_map_printing')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/6367020-yield-recording-and-reporting"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/yield-recording.png"
                        alt="Aerial photo of a combine harvester harvesting a field"
                    />
                    <h2>{t('plan_info_title_yield_recording')}</h2>
                    <p>{t('plan_info_body_yield_recording')}</p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/5672217-using-the-pesticide-list-when-adding-inputs-to-field-jobs"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/pesticides.png"
                        alt="Photo of a farmer inspecting crops"
                    />
                    <h2>{t('inputs_pesticide_database')}</h2>
                    <p>
                        <strong>(UK, South Africa, Australia, Canada, New Zealand)</strong>{' '}
                        {t('plan_info_body_two_pesticides_database')}
                    </p>
                </a>
                <a
                    href="https://support.fieldmargin.com/en/articles/1869622-upload-your-paper-farm-maps-to-fieldmargin"
                    target="_blank"
                    rel="noreferer noopener"
                >
                    <StaticImage
                        src="../../images/plan-info/map-uploader.png"
                        alt="Aerial photo of a field"
                    />
                    <h2>{t('plan_info_title_map_uploader')}</h2>
                    <p>{t('plan_info_body_map_uploader')}</p>
                </a>
            </div>
            <PlanInfoFeaturesList />
        </>
    );
};

export default EssentialsInfo;
